import * as T_T from 'cryface';
import { PhoneNumberUtil, PhoneNumber, PhoneNumberFormat } from 'google-libphonenumber';

export namespace ContactAgentValidator {
    export function phoneValidatorDepracated(rule: any, value: string, callback: any) {
        if (!T_T.simpleDetect(value)) {
            return callback(new Error('楼盘名称不能为空'));
        }
        return callback();
    }

    export function validator(data: any) {
        const errorStack: string[] = [];
        if (!T_T.simpleDetect(data.name.value)) {
            errorStack.push('姓名不能为空');
        }
        if (!T_T.simpleDetect(data.phone.value)) {
            errorStack.push('电话号码不能为空');
        }
        if (!(isDigit(data.phone.value)) || data.phone.value.length !== 10) {
            errorStack.push('电话号码格式不正确');
        }
        if (!T_T.simpleDetect(data.email.value)) {
            errorStack.push('电子邮箱地址不能为空');
        }
        if (!isEmail(data.email.value)) {
            errorStack.push('电子邮箱地址格式不正确');
        }
        if (!T_T.simpleDetect(data.remark.value)) {
            errorStack.push('备注不能为空');
        }
        if (errorStack.length > 0) {
            return errorStack[0];
        } else {
            return null;
        }
    }

    export function isDigit(val: string) {
        return T_T.isMatchRegex(val, /^\d+$/);
    }

    export function isEmail(val: string) {
        const emailText = val;
        const pattern = /^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[a-z0-9]+(\-[a-z0-9]+)*)*\.[a-z]{2,4}$/;
        if (pattern.test(emailText)) {
            return true;
        } else {
            return false;
        }
    }
}
